import { observer, useLocalObservable } from "mobx-react"
import { Flex, Table } from "antd"
import { choose } from "choose-matching"

import { LoadingBlock } from "@src/app/components/LoadingBlock"
import { BankPayoutsCollection } from "@src/pages/transactionsBankPayouts/classes/BankPayoutsCollection"
import { TransactionsBanksPayoutsColumns } from "@src/pages/transactionsBankPayouts/constants"
import { TransactionsOutEmpty } from "@src/pages/transactionsOut/constants"
import { TableFilters } from "@src/shared/componemts/TableFilter"

export const TransactionsBankPayouts = observer(() => {
  const collection = useLocalObservable(() => new BankPayoutsCollection())

  return (
    <Flex gap={16} vertical>
      <TableFilters {...collection.filter.props} />
      {choose(
        [collection.isLoading && collection.isEmpty, <LoadingBlock />],
        [collection.isEmpty, <TransactionsOutEmpty />],
        [
          !collection.isEmpty,
          <Table
            columns={TransactionsBanksPayoutsColumns}
            dataSource={collection.items}
            loading={collection.isLoading}
            pagination={collection.pagination}
            scroll={{ x: true }}
            style={{ width: "100%" }}
          />,
        ],
      )}
    </Flex>
  )
})
